import {ICellRendererParams} from '../types/AgGridTypes';

export const getUnformattedValue = (cellRendererProps: ICellRendererParams) =>
  cellRendererProps.getValue ? cellRendererProps.getValue() : cellRendererProps.value;
